import { Divider, Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useCaseStore } from '../../../../../../../store/hooks';

import { CheckedIconContainer } from '../../../checkedIcon/CheckedIcon';
import { Text } from '../../../Description.styled';
import { Input } from '../../../../../../shared/ui/form/input/Input';
import { getDate } from '../../../../../../../utils/dateSort';
import { ISecondStageValuesCushingV2 } from '../../../../../user/caseDraft/stages/cushing-v2/secondStage/SecondStage.types';
import { AttachmentThumbnail } from '../../../attachmentThumbnail/AttachmentThumbnail';

export const SecondStage = observer(() => {
  const caseStore = useCaseStore();

  const { secondStage } = caseStore as { secondStage: ISecondStageValuesCushingV2 };

  if (!secondStage) {
    return null;
  }
  const currentDiagnosisSection = Boolean(secondStage.currentDiagnosisCushing);

  const currentDiagnosisColumn = Boolean(secondStage.currentDiagnosisCushing)
    ? secondStage.currentDiagnosisCushing === 'zespół ektopowej produkcji ACTH'
      ? secondStage.currentDiagnosisProductionACTHCheck
      : secondStage.currentDiagnosisAdrenalCushingCheck
    : null;

  return (
    <Grid container justifyContent={'space-between'} width={'100%'}>
      <Typography variant={'h5'}>Dane dotyczące choroby zasadniczej i etiologii hiperkortyzolemii</Typography>

      {currentDiagnosisSection && currentDiagnosisColumn && (
        <Grid container display={'flex'} alignItems={'center'} mt={2}>
          {currentDiagnosisSection && (
            <>
              <Typography width={'100%'} variant={'h6'}>
                Aktualne rozpoznanie:
              </Typography>
              <Grid item xs={6} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                <CheckedIconContainer />
                <Text>{secondStage.currentDiagnosisCushing}</Text>
              </Grid>
              <>
                {currentDiagnosisColumn && (
                  <Grid item xs={6}>
                    <Input
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'currentDiagnosisColumn'}
                      type={'text'}
                      value={currentDiagnosisColumn}
                    />
                  </Grid>
                )}
              </>
              <>
                {secondStage.currentDiagnosisProductionACTHOther && (
                  <Grid item xs={6}>
                    <Input
                      disabled
                      variant={'standard'}
                      fullWidth={true}
                      name={'currentDiagnosisProductionACTHOther'}
                      label={'Inny'}
                      type={'text'}
                      value={secondStage.currentDiagnosisProductionACTHOther}
                    />
                  </Grid>
                )}
              </>
            </>
          )}
        </Grid>
      )}

      {(secondStage.courseWhoRecognized || secondStage.courseDateStart) && (
        <Grid container display={'flex'} alignItems={'center'} mt={2}>
          <Typography variant={'h6'} mb={2} width={'100%'}>
            Kto rozpoznał zespół Cushinga:
          </Typography>
          <Grid item xs={4} pr={1}>
            <Input
              disabled
              variant={'standard'}
              fullWidth={true}
              name={'courseWhoRecognized'}
              label={'Kto rozpoznał / specjalizacja'}
              type={'text'}
              value={secondStage.courseWhoRecognized}
            />
          </Grid>
          <Grid item xs={4} pr={1} pl={1}>
            <Input
              disabled
              variant={'standard'}
              fullWidth={true}
              name={'courseDateStart'}
              label={'Data rozpoznania'}
              type={'text'}
              maxLength={2}
              value={getDate(secondStage.courseDateStart)}
            />
          </Grid>
        </Grid>
      )}
      {(secondStage.hormonalTestDuringTheDiagnosisCortisol ||
        secondStage.hormonalTestDuringTheDiagnosisCortisolEvening ||
        secondStage.hormonalTestDuringTheDiagnosisCortisolDeks ||
        secondStage.hormonalTestDuringTheDiagnosisACTH ||
        secondStage.hormonalTestDuringTheDiagnosisFreeCortisol ||
        secondStage.hormonalTestDuringTheDiagnosisMLNSC ||
        secondStage.hormonalTestDuringTheDiagnosisCRH ||
        secondStage.hormonalTestDuringTheDiagnosisDesmopressin ||
        secondStage.hormonalTestDuringTheDiagnosisDexamethasone) && (
        <Grid container display={'flex'} alignItems={'flex-start'} mt={2}>
          <Typography mt={2} variant={'h6'}>
            Badania hormonalne w okresie ustalania rozpoznania:
          </Typography>
          <Grid container display={'flex'} alignItems={'flex-start'}>
            {secondStage.hormonalTestDuringTheDiagnosisCortisol && (
              <>
                <Grid item xs={8} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
                  <CheckedIconContainer />
                  <Text>{'kortyzol w surowicy w godzinach porannych'}</Text>
                </Grid>
                <Grid item xs={4} pl={2} alignSelf={'stretch'} mt={2}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'hormonalTestDuringTheDiagnosisCortisol'}
                    label={'(μg/dL)'}
                    type={'text'}
                    value={secondStage.hormonalTestDuringTheDiagnosisCortisol}
                  />
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisCortisolEvening && (
              <>
                <Grid
                  item
                  xs={8}
                  pl={2}
                  display={'flex'}
                  alignItems={'center'}
                  justifyItems={'center'}
                  alignSelf={'stretch'}
                  mt={2}
                >
                  <CheckedIconContainer />
                  <Text>{'kortyzol w surowicy w godzinach późnowieczornych'}</Text>
                </Grid>
                <Grid item xs={4} pl={2} alignSelf={'stretch'} mt={2}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'hormonalTestDuringTheDiagnosisCortisolEvening'}
                    label={'(μg/dL)'}
                    type={'text'}
                    value={secondStage.hormonalTestDuringTheDiagnosisCortisolEvening}
                  />
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisCortisolDeks && (
              <>
                <Grid item xs={8} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
                  <CheckedIconContainer />
                  <Text>{'kortyzol w surowicy w teście z 1 mg deksametazonu'}</Text>
                </Grid>
                <Grid item xs={4} pl={2} alignSelf={'stretch'} mt={2}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'hormonalTestDuringTheDiagnosisCortisolDeks'}
                    label={'(μg/dL)'}
                    type={'text'}
                    value={secondStage.hormonalTestDuringTheDiagnosisCortisolDeks}
                  />
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisACTH && (
              <>
                <Grid item xs={8} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
                  <CheckedIconContainer />
                  <Text>{'ACTH w osoczu w godzinach porannych'}</Text>
                </Grid>
                <Grid item xs={4} pl={2} alignSelf={'stretch'} mt={2}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'hormonalTestDuringTheDiagnosisACTH'}
                    label={'(μg/ml)'}
                    type={'text'}
                    value={secondStage.hormonalTestDuringTheDiagnosisACTH}
                  />
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisFreeCortisol && (
              <>
                <Grid
                  item
                  xs={8}
                  pl={2}
                  display={'flex'}
                  alignItems={'center'}
                  justifyItems={'center'}
                  alignSelf={'stretch'}
                  mt={2}
                >
                  <CheckedIconContainer />
                  <Text>{'mUFC (wolny kortyzol w moczu, optymalnie średnia z dwóch lub trzech DZM)'}</Text>
                </Grid>
                <Grid item xs={4} pl={2} alignSelf={'center'} mt={2}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'hormonalTestDuringTheDiagnosisFreeCortisol'}
                    label={'(μg/dobę)'}
                    type={'text'}
                    value={secondStage.hormonalTestDuringTheDiagnosisFreeCortisol}
                  />
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisMLNSC && (
              <>
                <Grid item xs={8} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
                  <CheckedIconContainer />
                  <Text>
                    {'mLNSC (kortyzol w ślinie w godzinach późnowieczornych, optymalnie średnia z dwóch oznaczeń)'}
                  </Text>
                </Grid>
                <Grid item xs={4} pl={2} mt={2} alignSelf={'center'}>
                  <Input
                    multiline
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'hormonalTestDuringTheDiagnosisMLNSC'}
                    label={'(nmol/L)'}
                    type={'text'}
                    value={secondStage.hormonalTestDuringTheDiagnosisMLNSC}
                  />
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisCRH && (
              <>
                <Grid item xs={12} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'} mt={2}>
                  <CheckedIconContainer />
                  <Text>{'test z CRH'}</Text>
                </Grid>
                <Grid item xs={12} ml={4} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{secondStage.hormonalTestDuringTheDiagnosisCRH}</Text>
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisDesmopressin && (
              <>
                <Grid item xs={6} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{'test z desmopresyną'}</Text>
                </Grid>
                <Grid item xs={12} ml={4} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{secondStage.hormonalTestDuringTheDiagnosisDesmopressin}</Text>
                </Grid>
              </>
            )}
            {secondStage.hormonalTestDuringTheDiagnosisDexamethasone && (
              <>
                <Grid item xs={6} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{'test z „wysoką” dawką deksametazonu'}</Text>
                </Grid>
                <Grid item xs={12} ml={4} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>{secondStage.hormonalTestDuringTheDiagnosisDexamethasone}</Text>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      )}
      <>
        {secondStage.imagingResultMrTkMacroMicroadenoma && (
          <Grid container display={'flex'} alignItems={'center'} justifyItems={'center'}>
            <Typography mt={2} variant={'h6'}>
              Wynik obrazowania układu podwzgórzowo-przysadkowego w MR/TK:
            </Typography>
            <Grid container alignItems={'center'}>
              {secondStage.imagingResultMrTkMacroMicroadenoma && (
                <>
                  <Grid item xs={12} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                    <CheckedIconContainer />
                    <Text>{secondStage.imagingResultMrTkMacroMicroadenoma}</Text>
                  </Grid>
                </>
              )}
              {secondStage.imagingResultMrTkMacroadenomaInfiltration && (
                <>
                  <Grid item xs={12} ml={4} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                    <CheckedIconContainer />
                    <Text>{secondStage.imagingResultMrTkMacroadenomaInfiltration}</Text>
                  </Grid>
                </>
              )}
              {secondStage.infiltrationLeftActive && secondStage.infiltrationScaleLeft && (
                <>
                  <Grid item xs={12} ml={6} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                    <CheckedIconContainer />
                    <Text>lewa zatoka</Text>
                    <Grid item xs={4} pl={2} alignSelf={'stretch'}>
                      <Input
                        disabled
                        variant={'standard'}
                        fullWidth={true}
                        name={'infiltrationScaleLeft'}
                        label={'stopień w skali Knospa'}
                        type={'text'}
                        value={secondStage.infiltrationScaleLeft}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {secondStage.infiltrationRightActive && secondStage.infiltrationScaleRight && (
                <>
                  <Grid item xs={12} ml={6} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                    <CheckedIconContainer />
                    <Text>prawa zatoka</Text>
                    <Grid item xs={4} pl={2} alignSelf={'stretch'}>
                      <Input
                        disabled
                        variant={'standard'}
                        fullWidth={true}
                        name={'infiltrationScaleRight'}
                        label={'stopień w skali Knospa'}
                        type={'text'}
                        value={secondStage.infiltrationScaleRight}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {secondStage.imagingResultMrTkOther && (
                <Grid item xs={12}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'imagingResultMrTkOther'}
                    label={'Inne'}
                    type={'text'}
                    value={secondStage.imagingResultMrTkOther}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </>
      <>
        {(secondStage.otherMethodsTkActive ||
          secondStage.otherMethodsOtherActive ||
          secondStage.otherMethodsSomatostatinActive ||
          secondStage.otherMethods68PETActive ||
          secondStage.otherMethods18PETActive) && (
          <Grid container display={'flex'} alignItems={'center'} justifyItems={'center'}>
            <Typography mt={2} variant={'h6'}>
              Inne metody obrazowania
            </Typography>
            <Grid container alignItems={'center'}>
              {secondStage.otherMethodsTkActive && (
                <Grid item xs={12} pl={2} mt={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>TK</Text>
                </Grid>
              )}
              {secondStage.otherMethodsTkArray?.length > 0 && (
                <Grid container ml={4}>
                  {secondStage.otherMethodsTkArray?.map((el) => (
                    <Grid key={el} item pr={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                      <CheckedIconContainer />
                      <Text>{el}</Text>
                    </Grid>
                  ))}
                </Grid>
              )}
              {secondStage.otherMethodsTkDescription && (
                <Grid item xs={12}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'otherMethodsTkDescription'}
                    label={'Opis TK'}
                    type={'text'}
                    value={secondStage.otherMethodsTkDescription}
                  />
                </Grid>
              )}
              <AttachmentThumbnail file={secondStage.otherMethodsTkFiles} />
            </Grid>

            <Grid container alignItems={'center'}>
              {secondStage.otherMethodsSomatostatinActive && (
                <Grid item xs={12} pl={2} mt={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>scyntygrafia receptorów somatostatynowych</Text>
                </Grid>
              )}
              {secondStage.otherMethodsSomatostatinResult && (
                <Grid item xs={12}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'otherMethodsSomatostatinResult'}
                    label={'Wynik'}
                    type={'text'}
                    value={secondStage.otherMethodsSomatostatinResult}
                  />
                </Grid>
              )}
              <AttachmentThumbnail file={secondStage.otherMethodsSomatostatinFiles} />
            </Grid>
            <Grid container alignItems={'center'}>
              {secondStage.otherMethods68PETActive && (
                <Grid item xs={12} pl={2} mt={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>68Ga-DOTATATE PET CT</Text>
                </Grid>
              )}
              {secondStage.otherMethods68PETResult && (
                <Grid item xs={12}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'otherMethods68PETResult'}
                    label={'Wynik'}
                    type={'text'}
                    value={secondStage.otherMethods68PETResult}
                  />
                </Grid>
              )}
              <AttachmentThumbnail file={secondStage.otherMethods68PETFiles} />
            </Grid>
            <Grid container alignItems={'center'}>
              {secondStage.otherMethods18PETActive && (
                <Grid item xs={12} pl={2} mt={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>18F-FDG PET CT</Text>
                </Grid>
              )}
              {secondStage.otherMethods18PETResult && (
                <Grid item xs={12}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'otherMethods18PETResult'}
                    label={'Wynik'}
                    type={'text'}
                    value={secondStage.otherMethods18PETResult}
                  />
                </Grid>
              )}
              <AttachmentThumbnail file={secondStage.otherMethods18PETFiles} />
            </Grid>
            <Grid container alignItems={'center'}>
              {secondStage.otherMethodsOtherActive && (
                <Grid item xs={12} pl={2} mt={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <CheckedIconContainer />
                  <Text>Inne</Text>
                </Grid>
              )}
              {secondStage.otherMethodsOtherArray &&
                secondStage.otherMethodsOtherArray.length > 0 &&
                secondStage.otherMethodsOtherArray.map((el, index) => (
                  <Grid key={index}>
                    {secondStage.otherMethodsOtherArray[index].otherMethod && (
                      <Grid container display="flex" gap={2} flexWrap={'nowrap'} alignItems={'center'}>
                        <Typography variant={'subtitle1'}>{index + 1}</Typography>
                        <Grid item xs={12}>
                          <Input
                            disabled
                            variant={'standard'}
                            fullWidth={true}
                            name={`otherMethodsOtherArray[${index}]otherMethod`}
                            label={'Inne'}
                            type={'text'}
                            value={secondStage.otherMethodsOtherArray[index].otherMethod}
                          />
                        </Grid>
                      </Grid>
                    )}
                    <AttachmentThumbnail
                      file={secondStage.otherMethodsOtherArray[index]?.otherMethodFiles}
                      label="Załącznik:"
                    />
                  </Grid>
                ))}
            </Grid>
          </Grid>
        )}
      </>
      <>
        {secondStage.currentDiagnosisCushing === 'choroba Cushinga' && (
          <>
            <Grid container display={'flex'} alignItems={'center'} justifyItems={'center'}>
              <Typography mt={2} mb={2} variant={'h6'}>
                Badanie histopatologiczne:
              </Typography>
              <Grid container alignItems={'center'}>
                {secondStage.confirmationOfSomatotropicTissueMaterial && (
                  <Grid item xs={12} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                    <CheckedIconContainer />
                    <Text>potwierdzenie immunohistochemiczne guza kortykotropowego w materiale tkankowym</Text>
                  </Grid>
                )}
                {secondStage.proliferationMarkerKi67 && (
                  <>
                    <Grid item xs={3}>
                      <Text>MARKERY PROLIFERACJI Ki-67</Text>
                    </Grid>
                    <Grid item xs={9} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                      <CheckedIconContainer />
                      <Text>{secondStage.proliferationMarkerKi67}</Text>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            {secondStage.electronMicroscopicExamination && (
              <>
                <Grid container display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <Typography mt={2} mb={2} variant={'h6'}>
                    Badanie w mikroskopie elektronowym:
                  </Typography>
                  <Grid container alignItems={'center'}>
                    <Grid item xs={12} pl={2} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                      <CheckedIconContainer />
                      <Text>{secondStage.electronMicroscopicExamination}</Text>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </>
        )}
      </>

      {secondStage.currentDiagnosisCushing === 'zespół ektopowej produkcji ACTH' && (
        <>
          <Grid container display={'flex'} alignItems={'center'} justifyItems={'center'}>
            <Typography mt={2} mb={2} variant={'subtitle1'}>
              Zespół ektopowej produkcji ACTH:
            </Typography>
            <Typography mt={2} mb={2} variant={'subtitle1'}>
              Nowotwór neuroendokrynny trzustki
            </Typography>
            <Grid container alignItems={'center'}>
              {secondStage.pancreaticNeuroendocrineTumor && (
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'} mb={2}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'pancreaticNeuroendocrineTumor'}
                    label={'Ki-67'}
                    type={'text'}
                    value={secondStage.pancreaticNeuroendocrineTumor}
                  />
                </Grid>
              )}
              {secondStage.otherPancreaticNeuroendocrineTumor && (
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'otherPancreaticNeuroendocrineTumor'}
                    label={'Inne markery nowotworowe'}
                    type={'text'}
                    value={secondStage.otherPancreaticNeuroendocrineTumor}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid container display={'flex'} alignItems={'center'} justifyItems={'center'}>
            <Typography mt={2} mb={2} variant={'h6'}>
              ACTH-niezależny zespół Cushinga:
            </Typography>
            <Grid container alignItems={'center'}>
              {secondStage.acthIndependentCushingSyndrome && (
                <Grid item xs={12} display={'flex'} alignItems={'center'} justifyItems={'center'}>
                  <Input
                    disabled
                    variant={'standard'}
                    fullWidth={true}
                    name={'acthIndependentCushingSyndrome'}
                    label={'Rozpoznanie histopatologiczne'}
                    type={'text'}
                    value={secondStage.acthIndependentCushingSyndrome}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      )}
      <Grid item xs={12} my={4}>
        <Divider sx={{ width: '100%' }} />
      </Grid>
    </Grid>
  );
});
